var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import * as React from 'react';
import withPaddingAndMargin from '../withPaddingAndMargin';

var Col = function Col(props) {
  var className = props.className,
      nb = props.nb,
      np = props.np,
      otherProps = _objectWithoutProperties(props, ['className', 'nb', 'np']);

  var columnsAndNoPadding = 'dd-col-' + (nb || 'auto') + (np ? '-np' : '');
  return React.createElement('section', _extends({
    className: columnsAndNoPadding + ' ' + props.className
  }, otherProps));
};

export default withPaddingAndMargin(Col);